<template>
  <div class="event-item" :class="eventClass" :style="eventItemStyle">
    <div class="event-item__text" :class="textClass">
      <i v-if="iconClass" :class="iconClass" />
      <span v-else>{{ index }}</span>
    </div>
    <div v-if="point.is_moved" class="event-item__moved-indicator" />
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import moment from 'moment'

export default {
  props: {
    index: {
      type: Number,
      default: 0,
    },
    point: {
      type: Object,
      default: () => ({}),
    },
    color: {
      type: String,
      default: '#000000',
    },
    expectedStartTime: {
      type: String,
    },
    totalMinutes: {
      type: Number,
    },
    endPointWidth: {
      type: Number,
      default: 50, // default 25px sesuai CSS .__end
    },
    isDragging: {
      type: Boolean,
      default: false,
    },
    isStartPoint: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      startPosition: 0,
      eventWidth: 0,
      fixedPointWidth: 0,
    }
  },
  computed: {
    isStart() {
      return this.isStartPoint
    },
    isIdle() {
      return this.point.type === 'IDLE'
    },
    isEnd() {
      return this.point.type === 'END'
    },
    isBreak() {
      return this.point.type === 'BREAK'
    },
    eventClass() {
      return {
        __error: this.point.is_error,
        __start: this.isStart,
        __idle: this.isIdle,
        __end: this.isEnd,
        __dragging: this.isDragging,
      }
    },
    iconClass() {
      if (this.isStart) return 'icon-fill_home'
      if (this.isBreak) return 'icon-outline_timer'
      if (this.isIdle) return 'icon-outline_truck-idle'
      if (this.isEnd) return 'icon-fill_flag'
      return null
    },
    textClass() {
      return {
        'event-item__text--start': this.isStart,
        'event-item__text--idle': this.isIdle,
        'event-item__text--end': this.isEnd,
      }
    },
    eventItemStyle() {
      const base = this.isEnd
        ? `left: ${this.startPosition}%; --dynamic-color: ${this.color};`
        : `left: ${this.startPosition}%; width: ${this.eventWidth}%; --dynamic-color: ${this.color};`

      const style =
        this.isStart || this.isIdle || this.isEnd
          ? `background-color: white; border: 2px solid ${this.color};`
          : `background-color: ${this.color};`
      return base + style
    },
  },
  mounted() {
    this.calculateEventStyle()
  },
  methods: {
    async calculateEventStyle() {
      const isFixedPoint = this.point.type === 'END'
      const startTime = moment(this.point.estimated_process_on)
      const startCol = moment(this.expectedStartTime).minutes(0)

      const adjustedTotal = this.totalMinutes
      const calculatedStartPosition = (startTime.diff(startCol, 'minutes') / adjustedTotal) * 100

      await this.$nextTick()

      const duration = moment.duration(this.point.service_time).asMinutes()
      const calculatedWidth = (duration / adjustedTotal) * 100
      this.eventWidth = calculatedWidth
      this.fixedPointWidth = this.$el?.offsetWidth || this.endPointWidth

      if (isFixedPoint) {
        const containerWidth = this.$el?.parentElement?.offsetWidth || 1000
        const offsetPercent = (this.fixedPointWidth / containerWidth) * 100
        this.startPosition = calculatedStartPosition - offsetPercent / 2
      } else {
        this.startPosition = calculatedStartPosition
      }
    },
  },
}
</script>
<style lang="scss" scoped>
.event-item {
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  height: 30px;
  border-radius: 5px;
  display: flex;
  overflow: visible;
  z-index: 2;

  &.__error {
    border: 2px solid $white;
    box-shadow: 0 0 10px #ff0000;
  }

  &__text {
    flex: 1;
    margin: auto;
    color: $white;
    text-align: center;

    i {
      font-size: 16px;

      &:before {
        color: $white;
      }
    }

    &--start,
    &--idle,
    &--end {
      color: var(--dynamic-color);
    }
  }

  &.__start .event-item__text--start i:before,
  &.__idle .event-item__text--idle i:before,
  &.__end .event-item__text--end i:before {
    color: var(--dynamic-color);
  }

  &.__start {
    height: 30px;
    z-index: 3;
  }

  &.__end {
    width: 25px !important;
    height: 25px;
    border-radius: 50%;
    min-width: 25px;
  }

  .event-item__moved-indicator {
    position: absolute;
    top: -5px;
    right: -5px;
    width: 12px;
    height: 12px;
    border-radius: 50%;
    background-color: $green;
    border: 2px solid $white;
    z-index: 2;
  }

  &.__dragging {
    background-color: $blue-100 !important;
  }
}
</style>
